<template>
  <div>
    <alert-box ref="alertBox" class="spacer-bottom-l" />

    <div class="row">
      <div class="col-xs-12 col-md-6">
        <input-field
          :label="`Número do cartão de crédito`"
          :error-message="errors.cardNumber"
          placeholder="Informe o número"
          v-model.trim="card.number"
          v-mask="['#### #### #### ####', '#### #### #### #### ###']"
        />
      </div>

      <div class="col-xs-12 col-md-6">
        <input-field
          :label="`Nome escrito no cartão de crédito`"
          :error-message="errors.cardHolderName"
          placeholder="Nome igual está no cartão"
          v-model.trim="card.holderName"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12 col-md-6">
        <input-field
          label="Data de expiração"
          :error-message="errors.cardExpirationDate"
          placeholder="MM/AA"
          v-model.trim="card.expirationDate"
          v-mask="'##/##'"
        />
      </div>

      <div class="col-xs-12 col-md-6">
        <input-field
          label="Código de segurança"
          :error-message="errors.cardCvv"
          placeholder="Código atrás do cartão"
          v-model.trim="card.cvv"
          help-text="Código de 3 dígitos no verso do cartão ou de 4 digitos na frente no caso do American Express"
        />
      </div>
    </div>

    <button class="z-button z-button--primary z-button--block" @click="submitForm">
      Cadastrar cartão de crédito
    </button>
  </div>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import AlertBox from 'components/zilla/alert-box';
import CardService from 'services/CardService';
import InputField from 'components/zilla/input-field';

export default {
  props: {
    cardType: {
      type: String,
      required: true,
      validator: (cardType) => cardType === 'credit_card',
    },
  },
  data() {
    return {
      card: {
        number: '',
        holderName: '',
        expirationDate: '',
        cvv: '',
      },
      errors: {
        cardNumber: '',
        cardHolderName: '',
        cardExpirationDate: '',
        cardCvv: '',
      },
    };
  },
  components: {
    AlertBox,
    InputField,
  },
  methods: {
    submitForm() {
      // this is the format the back-end requires
      const card = {
        card_number: this.card.number,
        card_holder_name: this.card.holderName,
        card_expiration_date: this.card.expirationDate,
        card_cvv: this.card.cvv,
        card_type: this.cardType,
      };

      if (this.validateCard(card)) {
        this.$pageLoader.wrap(this.saveCard(card), 'Cadastrando cartão de crédito');
      }
    },
    validateCard(card) {
      this.clearErrors();

      const { cardValid, ...validations } = CardService.validateCard(card);

      if (!cardValid || isEmpty(card.card_holder_name)) {
        if (!validations.card_number) {
          this.errors.cardNumber = 'Número do cartão inválido';
        }
        if (!validations.card_holder_name || isEmpty(card.card_holder_name)) {
          this.errors.cardHolderName = 'Nome inválido';
        }
        if (!validations.card_expiration_date) {
          this.errors.cardExpirationDate = 'Data inválida';
        }
        if (!validations.card_cvv) {
          this.errors.cardCvv = 'Código inválido';
        }
        return false;
      }

      return true;
    },
    saveCard(cardPayload) {
      return CardService.createCard(cardPayload)
        .then((card) => {
          this.$emit('cardCreated', card);
        })
        .catch((error) => {
          if (error.response && error.response.status === 422 && error.response.data?.errors === 'Cartão inválido') {
            this.$refs.alertBox.show('danger', 'Cartão inválido', 'Verifique os dados informados e tente novamente.');
            return;
          }

          if (error.response && error.response.status >= 500) {
            this.$rollbar.error(`Erro ao cadastrar cartão no billing ${error}`);
          }

          this.$refs.alertBox
            .show('danger', 'Erro ao cadastrar cartão', 'Verifique os dados informados e tente novamente.');
        });
    },
    clearErrors() {
      this.errors = {
        cardNumber: '',
        cardHolderName: '',
        cardExpirationDate: '',
        cardCvv: '',
      };
    },
  },
};
</script>
